import { FunctionComponent} from 'preact';
import { getTranslation } from '../../../../shared/chromeApi';

import styles from './../styles.module.scss';

const AddTileShortcut: FunctionComponent<{
  onClick: () => void;
  noTiles: boolean;
}> = ({ onClick, noTiles }: { onClick: () => void; noTiles: boolean }) => (
  <button
    className={`${styles.addShortcutBtn} ${noTiles ? styles.noTiles : ''}`}
    onClick={onClick}
  >
    <span className={styles.plusSign}>+</span>
    {getTranslation('new_tab_add_shortcut')}
  </button>
);

export default AddTileShortcut;
